module.exports = __webpack_public_path__ + "img/zalopay.e9d85436.svg";